import React from "react";
import { Modal } from "@mantine/core";
import zIndex from "../../designTokens/zIndex";
import { CardPost } from "../Card/CardPost";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { useState, useEffect } from "react";
import { CardPostBig } from "../Card/CardPostBig";

const ThreadModal = ({ isOpen, onClose, title, threads, isMobile }) => {
	const [sortedPosts, setSortedPosts] = useState([]);

	useEffect(() => {
		// Calculate viewRank
		const threadsByViews = [...threads].sort((a, b) => b.views - a.views);
		threadsByViews.forEach((thread, index) => {
			thread.viewRank = index + 1;
		});

		// Calculate engagementRank
		const threadsByEngagement = [...threads].sort((a, b) => {
			const engagementA = a.likes * 1 + a.replies * 2 + a.reposts * 3;
			const engagementB = b.likes * 1 + b.replies * 2 + b.reposts * 3;
			return engagementB - engagementA;
		});
		threadsByEngagement.forEach((thread, index) => {
			thread.engagementRank = index + 1;
		});

		// Combine ranks into a single array
		const threadsWithRanks = threads.map((thread) => ({
			...thread,
			viewRank: thread.viewRank,
			engagementRank: thread.engagementRank,
		}));

		setSortedPosts(threadsWithRanks);
	}, [threads]);

	return (
		<Modal
			size={isMobile ? "100%" : "80%"}
			opened={isOpen}
			onClose={onClose}
			title={title}
			centered
			zIndex={zIndex.modal}
		>
			<ResponsiveMasonry columnsCountBreakPoints={{ 750: 2, 900: 4 }}>
				<Masonry columnsCount={isMobile ? 2 : 4} gutter="8px">
					{sortedPosts.map((thread) => {
						const isTopPost = thread.viewRank < 4 || thread.engagementRank < 4;
						return isTopPost ? (
							<CardPost
								rd={8}
								isMobile={isMobile}
								key={thread.id}
								thread={thread}
								date={thread.timestamp}
							/>
						) : (
							<CardPost
								rd={8}
								isMobile={isMobile}
								key={thread.id}
								thread={thread}
								date={thread.timestamp}
							/>
						);
					})}
				</Masonry>
			</ResponsiveMasonry>
		</Modal>
	);
};

export default ThreadModal;
